const routes = [{
  path: '/humanOrganization/detail',
  component: () => import('@/views/organization/detail'),
  name: 'human-organization-detail',
  meta: {
    title: '组织机构管理/详情'
  }
}, {
  path: '/organization/importRecords',
  component: () => import('@/views/organization/importRecords'),
  name: 'organization-importRecords',
  meta: {
    title: '组织机构批量导入记录'
  }
}, {
  path: '/organization/group',
  component: () => import('@/views/organization/group'),
  name: 'organization-group',
  meta: {
    title: '集团组织机构管理'
  }
}, {
  path: '/organization/mark',
  component: () => import('@/views/organization/mark'),
  name: 'organization-mark',
  meta: {
    title: '组织标签管理'
  }
}, {
  path: '/human',
  name: 'human',
  component: () => import('@/views/human/index')
}, {
  path: '/organization/home',
  component: () => import('@/views/organization/home'),
  name: 'organization-home',
  meta: {
    title: '组织维护管理'
  }
}, {
  path: '/organization/task',
  component: () => import('@/views/organization/task'),
  name: 'organization-task',
  meta: {
    title: '组织维护管理任务列表'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/human/organization.js